import pdfjsPackage from 'pdfjs-dist/package.json';

export const PDFJS_WORKER_URL = `https://unpkg.com/pdfjs-dist@${pdfjsPackage.version}/build/pdf.worker.min.js`;
